// eslint-disable-next-line no-undef
ArticleEditor.add('plugin', 'definedlinks', {
  defaults: {
    items: false
  },
  subscribe: {
    'popup.open' () {
      if (this.opts.definedlinks.items === false) { return }

      const stack = this.app.popup.getStack()
      const name = stack.getName()
      const names = ['link-create', 'link-edit']

      if (names.includes(name)) {
        this._build(stack)
      }
    }
  },

  // private
  _build (stack) {
    this.stack = stack

    const $item = stack.getFormItem('text')
    const $box = this.dom('<div>').addClass(this.prefix + '-form-item')

    // select
    this.$select = this._create()

    $box.append(this.$select)
    $item.before($box)
  },
  _change (e) {
    const key = this.dom(e.target).val()
    const data = this.opts.definedlinks.items[key]
    const $text = this.stack.getInput('text')
    const $url = this.stack.getInput('url')
    let name = data.text
    let url = data.placeholder

    if (data.placeholder === false) {
      url = ''
      name = ''
    }

    $text.val(name)
    $url.val(url)
  },
  _create () {
    const items = this.opts.definedlinks.items
    const $select = this.dom('<select>').addClass(this.prefix + '-form-select')
    $select.on('change', this._change.bind(this))

    for (let i = 0; i < items.length; i++) {
      const data = items[i]
      const $option = this.dom('<option>')
      $option.val(i)
      $option.html(data.name)

      $select.append($option)
    }

    return $select
  }
})
